import * as React from "react";
import { observer } from "mobx-react";
import { withStores } from "stores";
import { normalizeOptionsData, hasEmptyOptions } from "src/components/flexFramework/FlexTemplateNode";
import { UitkHeading } from "uitk-react-text";
import { TitleContainerProps, TitleContainerFTNodeOptions } from "./typings";
import { UitkSpacing, UitkSpacingProps } from "uitk-react-spacing";

export const TitleContainer = withStores(
  "flexModuleModelStore",
  "context"
)(
  observer((props: TitleContainerProps) => {
    const { flexTemplateNode, flexModuleModelStore } = props;

    /* istanbul ignore if */
    if (!flexTemplateNode || !flexModuleModelStore) {
      return null;
    }

    const { id } = flexTemplateNode;
    const options = normalizeOptionsData(
      flexTemplateNode,
      flexModuleModelStore.getModel(id)
    ) as TitleContainerFTNodeOptions;

    /* istanbul ignore next */
    if (hasEmptyOptions(options)) {
      return null;
    }

    /* istanbul ignore next */
    const getTitlePadding = (): UitkSpacingProps["padding"] => {
      return {
        blockend: options.hasPaddingBottom ? "three" : "unset",
        inline: options.hasInlinePadding ? "three" : "unset",
      };
    };

    return (
      <UitkSpacing padding={getTitlePadding()}>
        <UitkHeading tag="h2" size={3}>
          {options.title}
        </UitkHeading>
      </UitkSpacing>
    );
  })
);

export default TitleContainer;
